import { Award } from 'lucide-react';
import drLarkinHeadshot from '@/assets/dr-larkin-headshot.jpg';

export function CompanyHero() {
  return (
    <section className="pt-32 md:pt-40 pb-20 md:pb-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-12 lg:gap-20 items-center">
          {/* Copy */}
          <div className="text-center lg:text-left">
            <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
              Our Story
            </p>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight text-foreground mb-6">
              Built by a Surgeon,
              <br />
              for the Surgical Integrity of Hospitals.
            </h1>

            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl mx-auto lg:mx-0">
              After 40 years in the operating room, Dr. Larkin saw a systemic
              failure in how hospitals were paid for their work. LINK is the
              solution he built to fix it.
            </p>
          </div>

          {/* Executive Profile Card */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative w-60 h-80 sm:w-[17rem] sm:h-[22rem] md:w-[19rem] md:h-[25rem] rounded-xl border border-border bg-card overflow-hidden">
              <div className="absolute inset-0">
                <img
                  src={drLarkinHeadshot}
                  alt="Dr. John J. Larkin, M.D. — Founder & Clinical Architect of LINK"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card/95 via-card/40 via-50% to-transparent" />
              </div>

              <div className="absolute top-3 right-3 z-20">
                <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-warning">
                  <Award className="h-3.5 w-3.5 text-warning-foreground" strokeWidth={2.5} />
                  <span className="text-[10px] font-bold text-warning-foreground tracking-wide uppercase">
                    Top Doctor
                  </span>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 z-10 p-5">
                <p className="text-base font-bold text-foreground tracking-tight">
                  John J. Larkin, M.D.
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  Founder &amp; Clinical Architect
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-[10px] text-primary font-medium">
                    40+ Years · Orthopedic Surgery
                  </span>
                  <span className="h-1 w-1 rounded-full bg-muted-foreground/30" />
                  <span className="text-[10px] text-muted-foreground">
                    Yale · UK
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
